import { CardViewIcon } from '../../assets/svg/card-view';
import { TableViewIcon } from '../../assets/svg/table-view';
import { viewStyleKey } from '../../helpers/path';
import { useLang } from '../../hooks/use-lang';
import { DropdownSelector } from '../dropdown-selector/dropdown-selector';

export const DropdownStyleView = () => {
  const { t } = useLang();

  return (
    <DropdownSelector
      selectorKey={viewStyleKey}
      className="hide__M hide__S"
      options={[
        {
          label: t('Таблица'),
          icon: <TableViewIcon />,
          value: 'table',
        },
        { label: t('Карточки'), icon: <CardViewIcon />, value: 'card' },
      ]}
    />
  );
};
